module.exports = __webpack_public_path__ + "static/media/logo.144cd908.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderBar/logos/healthinmotion/logo.png
// module id = 984
// module chunks = 0